import React, { useState } from 'react';

interface Props {
    onAccept: () => void;
}

const SafetyDisclaimer: React.FC<Props> = ({ onAccept }) => {
    const [checked, setChecked] = useState(false);

    return (
        <div style={{
            position: 'fixed', inset: 0,
            background: 'rgba(15, 23, 42, 0.85)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999,
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        }}>
            <div style={{
                background: '#fff',
                borderRadius: 16,
                maxWidth: 560,
                width: '90%',
                padding: '40px 36px',
                boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)',
            }}>
                <div style={{ textAlign: 'center', marginBottom: 24 }}>
                    <div style={{
                        width: 56, height: 56, borderRadius: '50%',
                        background: '#fef3c7', display: 'inline-flex',
                        alignItems: 'center', justifyContent: 'center',
                        fontSize: 28, marginBottom: 12,
                    }}>
                        ⚠️
                    </div>
                    <h2 style={{ color: '#0f172a', fontSize: 22, margin: '0 0 8px', fontWeight: 700 }}>
                        Important Safety Notice
                    </h2>
                    <p style={{ color: '#64748b', fontSize: 14, margin: 0 }}>
                        Synterra Health platform
                    </p>
                </div>

                <div style={{
                    background: '#f8fafc', borderRadius: 12, padding: '20px 24px',
                    marginBottom: 24, border: '1px solid #e2e8f0',
                }}>
                    <p style={{ color: '#334155', fontSize: 15, lineHeight: 1.7, margin: '0 0 16px' }}>
                        The Synterra Health platform is an AI-assisted implementation science platform designed to support
                        implementation support for health service delivery. It helps humans make
                        informed decisions about <strong>non-life-threatening</strong> implementation challenges.
                    </p>
                    <p style={{ color: '#334155', fontSize: 15, lineHeight: 1.7, margin: '0 0 16px' }}>
                        This platform is <strong>not a substitute for clinical judgment</strong> and should
                        never be used for decisions involving immediate risk to human life or safety.
                    </p>
                    <div style={{
                        background: '#fef2f2', border: '1px solid #fecaca',
                        borderRadius: 8, padding: '12px 16px',
                    }}>
                        <p style={{ color: '#991b1b', fontSize: 14, fontWeight: 600, margin: '0 0 4px' }}>
                            If you encounter a situation involving immediate risk:
                        </p>
                        <p style={{ color: '#7f1d1d', fontSize: 14, margin: 0 }}>
                            Stop using the platform and contact a qualified human professional immediately.
                        </p>
                    </div>
                </div>

                <label style={{
                    display: 'flex', alignItems: 'flex-start', gap: 12,
                    cursor: 'pointer', marginBottom: 24, padding: '0 4px',
                }}>
                    <input
                        type="checkbox"
                        checked={checked}
                        onChange={(e) => setChecked(e.target.checked)}
                        style={{ width: 18, height: 18, marginTop: 2, cursor: 'pointer', accentColor: '#0d9488' }}
                    />
                    <span style={{ color: '#334155', fontSize: 14, lineHeight: 1.6 }}>
                        I understand that the Synterra Health platform is not for life-threatening decisions.
                        I agree to escalate to a qualified human professional when a situation
                        involves immediate risk to human life or safety.
                    </span>
                </label>

                <button
                    onClick={() => {
                        sessionStorage.setItem('spartis_safety_acknowledged', 'true');
                        onAccept();
                    }}
                    disabled={!checked}
                    style={{
                        width: '100%',
                        padding: '14px 24px',
                        borderRadius: 10,
                        border: 'none',
                        fontSize: 15,
                        fontWeight: 600,
                        cursor: checked ? 'pointer' : 'not-allowed',
                        background: checked ? '#0d9488' : '#cbd5e1',
                        color: checked ? '#fff' : '#94a3b8',
                        transition: 'all 0.2s',
                    }}
                >
                    I Acknowledge — Continue to the Synterra Health platform
                </button>

                <p style={{ textAlign: 'center', color: '#94a3b8', fontSize: 12, marginTop: 16, marginBottom: 0 }}>
                    Human-in-the-loop is a fundamental pillar of this platform.
                    AI-generated outputs are always subject to human review.
                </p>
            </div>
        </div>
    );
};

export default SafetyDisclaimer;
